import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Packages } from "@/components/site/Packages";
import { Gallery } from "@/components/site/Gallery";
import { Testimonials } from "@/components/site/Testimonials";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";
import { BlogTeaser } from "@/components/site/BlogTeaser";
import { Newsletter } from "@/components/site/Newsletter";
import { ServicesOverview } from "@/components/site/ServicesOverview";
import { HajiKhususTeaser } from "@/components/site/HajiKhususTeaser";
import { UmrohCustomTeaser } from "@/components/site/UmrohCustomTeaser";
import { VisaProvider } from "@/components/site/VisaProvider";
import { WhyUs } from "@/components/site/WhyUs";
import ScrollToTop from "@/components/ScrollToTop";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminInquiries from "@/pages/AdminInquiries";
import AdminBlog from "@/pages/AdminBlog";
import AdminBlogEditor from "@/pages/AdminBlogEditor";
import AdminPackages from "@/pages/AdminPackages";
import AdminPackageEditor from "@/pages/AdminPackageEditor";
import AdminNewsletter from "@/pages/AdminNewsletter";
import AdminGallery from "@/pages/AdminGallery";
import AdminAirports from "@/pages/AdminAirports";
import AdminHotels from "@/pages/AdminHotels";
import AdminItinerary from "@/pages/AdminItinerary";
import AdminBonus from "@/pages/AdminBonus";
import AdminTransports from "@/pages/AdminTransports";
import AdminAirlines from "@/pages/AdminAirlines";
import AdminAlbumEditor from "@/pages/AdminAlbumEditor";
import PackageDetail from "@/pages/PackageDetail";
import BlogList from "@/pages/BlogList";
import BlogDetail from "@/pages/BlogDetail";
import GalleryPage from "@/pages/GalleryPage";
import HajiKhusus from "@/pages/HajiKhusus";
import UmrohCustom from "@/pages/UmrohCustom";
import VisaUmroh from "@/pages/VisaUmroh";
import PackageListing from "@/pages/PackageListing";
import SEO from "@/components/SEO";
const Landing = () => (
  <div data-testid="landing-page" className="bg-[color:var(--bg)] text-main overflow-x-hidden">

    <SEO
      title="Baba Tour Umroh & Haji Khusus | Sahabat Perjalanan Ibadah Keluarga"
      description="Baba Tour melayani paket umroh keberangkatan Batam dan Palembang, haji khusus, visa umroh, serta perjalanan ibadah dengan pelayanan profesional dan berizin resmi."
    />

    <Header />

<main>
  <Hero />
  <ServicesOverview />
  <HajiKhususTeaser />
  <UmrohCustomTeaser />
  <VisaProvider />
  <About />
  <WhyUs />
  <Packages limit={6} />
  <Gallery />
  <Testimonials />
  <BlogTeaser />
  <Newsletter />
  <Faq />
</main>

    <Footer />
    <FloatingWhatsApp />
  </div>
);

function App() {
  return (
    <div className="App">
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/packages/:id" element={<PackageDetail />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/haji-khusus" element={<HajiKhusus />} />
	    <Route path="/umroh-custom" element={<UmrohCustom />} />
	    <Route path="/visa-umroh" element={<VisaUmroh />} />
            <Route path="/paket-umroh" element={<PackageListing />} />
            <Route path="/paket-umroh-batam" element={<PackageListing city="Batam" />} />
            <Route path="/paket-umroh-palembang" element={<PackageListing city="Palembang" />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminInquiries />} />
              <Route path="packages" element={<AdminPackages />} />
              <Route path="packages/new" element={<AdminPackageEditor />} />
              <Route path="packages/:id/edit" element={<AdminPackageEditor />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="blog/new" element={<AdminBlogEditor />} />
              <Route path="blog/:id/edit" element={<AdminBlogEditor />} />
              <Route path="gallery" element={<AdminGallery />} />
              <Route path="gallery/new" element={<AdminAlbumEditor />} />
              <Route path="gallery/:id/edit" element={<AdminAlbumEditor />} />
              <Route path="newsletter" element={<AdminNewsletter />} />
              <Route path="airports" element={<AdminAirports />} />         
              <Route path="airlines" element={<AdminAirlines />} />
              <Route path="hotels" element={<AdminHotels />} />
              <Route path="itinerary" element={<AdminItinerary />} />  
              <Route path="bonus" element={<AdminBonus />} />
              <Route path="transports" element={<AdminTransports />} /> 
</Route>
          </Routes>
          <Toaster richColors position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
   </div>
  );
}

export default App;
